/**
 * Set this property to `true` on an error prevent that error instance from
 * being reported to Sentry.
 *
 * This should only be used to dynamically ignore specific error instances. To
 * globally ignore a class of errors use `beforeSend` or `ignoreErrors` in
 * `Sentry.init({ ... })`.
 *
 * @example
 * try {
 *   // ...
 * } catch (error) {
 *   if (weDoNotCareAboutThis) {
 *     error[sentryPleaseIgnoreThis] = true;
 *   }
 *
 *   throw error;
 * }
 */
export const sentryPleaseIgnoreThis = Symbol('sentryPleaseIgnoreThis');

// Tell TypeScript to make sure we only set `sentryPleaseIgnoreThis` to `true`
// for all objects.
declare global {
	interface Object {
		[sentryPleaseIgnoreThis]?: true;
	}
}
